import React from "react";

import icon from "../images/icon-outline-alert.svg";

import "../styles/success-fail.scss";

const SlideOutModalFail = ({
  showTitle,
  onBack,
  message,
  caseNumber,
  buttonLanel,
  title,
  details,
}) => {
  const defaultMessage = (
    <div>
      There was an error completing your request. Please call the{" "}
      <b>Allstate Technology Support Center</b> at <b>800-729-3005</b> and press
      2 for assistance with this issue.
    </div>
  );
  const defaultButtonLabel = "Back to Client Details";
  const defaultTitle = "Oops!";

  return (
    <div className="success-fail">
      <img src={icon} alt="fail" />
      {showTitle === undefined || showTitle ? (
        <h1>{title || defaultTitle}</h1>
      ) : null}
      {message && <div className="content">{message}</div>}
      <div className="content">{defaultMessage}</div>
      {caseNumber && (
        <span>
          Case #: <b>{caseNumber}</b>
        </span>
      )}
      <div>{details}</div>
      <div
        style={{ cursor: "pointer" }}
        className="btn btn-default"
        onClick={onBack}
      >
        {buttonLanel || defaultButtonLabel}
      </div>
    </div>
  );
};
export default SlideOutModalFail;
